



















  import { defineComponent } from 'vue'

  export default defineComponent({
    name: 'OneRegistrationValidation',
    props: {
      value: {
        required: true,
        type: Boolean,
      },
      message: {
        required: true,
        type: String,
      },
    },
  })
